import { ADD_MYDATA_TILE, REMOVE_MYDATA_TILE } from '../../constants/reducerTypes';

const initialState = {};
const myDataReducer = (state = initialState, action) => {
  switch (action.type) {        
    case ADD_MYDATA_TILE:
      return {
        ...state,
        addMyTileResponse: action?.payload?.addMyTileResponse,        
        loader: action?.payload?.loader,
        hasError: action?.payload?.hasError
      };
    case REMOVE_MYDATA_TILE:
      return {
        ...state,
        removeMyTileResponse: action?.payload?.removeMyTileResponse,        
        loader: action?.payload?.loader,
        hasError: action?.payload?.hasError
      };  
    default:
      return state;
  }
};
export default myDataReducer;
